import {LogLevel, LoggerLike} from './logger';

export class ConsoleLogger implements LoggerLike {
  debug(message: string, ...optionalParams: unknown[]): void {
    // eslint-disable-next-line no-console
    console.debug(`[${this.generateTimestamp()}] [DEBUG] ${message}`, ...optionalParams);
  }
  error(message: string, ...optionalParams: unknown[]): void {
    // eslint-disable-next-line no-console
    console.error(`[${this.generateTimestamp()}] [ERROR] ${message}`, ...optionalParams);
  }
  info(message: string, ...optionalParams: unknown[]): void {
    // eslint-disable-next-line no-console
    console.info(`[${this.generateTimestamp()}] [INFO] ${message}`, ...optionalParams);
  }
  log(level: LogLevel, message: string, ...optionalParams: unknown[]): void {
    // eslint-disable-next-line no-console
    console.log(`[${this.generateTimestamp()}] [${level}] ${message}`, ...optionalParams);
  }
  warn(message: string, ...optionalParams: unknown[]): void {
    // eslint-disable-next-line no-console
    console.warn(`[${this.generateTimestamp()}] [WARN] ${message}`, ...optionalParams);
  }
  private generateTimestamp(): string {
    return new Date().toISOString();
  }
}
